import React from 'react';
import './PieChartTooltip.scss';

interface PieChartTooltipProps {
  tooltipData?: {
    name: string;
    fill: string;
    value: string | number;
    percent: string | number;
  };
}

const PieChartTooltip: React.FC<PieChartTooltipProps> = ({ tooltipData }) => {
  if (tooltipData) {
    const { name, fill, value, percent } = tooltipData;
    return (
      <div className="answer-data label">
        <div className="label-top">
          <span className="dot" style={{ backgroundColor: fill }} />
          <b>{name}</b>
        </div>
        <div className="label-bottom">
          {percent}% <span>({Number(value).toLocaleString()})</span>
        </div>
      </div>
    );
  }

  return null;
};

export default PieChartTooltip;
